export const YoutubeVideo = () => {
    const openYoutubeVideo = document.querySelectorAll('.trainers__play-btn');
    const youtubeContainer = document.getElementById('youtubeVideo');

    if (youtubeContainer !== null) {


        openYoutubeVideo.forEach((button) => {
            button.addEventListener('click', (e) => {
                const iframe = document.createElement("iframe");
                const embed = "https://www.youtube.com/embed/ID?autoplay=1";
                iframe.classList.add('w-full', 'h-full');
                iframe.setAttribute("frameborder", "0");
                iframe.setAttribute("allowfullscreen", "1");
                const videoID = e.currentTarget.dataset.video;
                iframe.setAttribute("src", embed.replace("ID", videoID));
                youtubeContainer.append(iframe);
            });
        });

        document.addEventListener('WEBsellentModalClosed', () => {
            youtubeContainer.querySelector('iframe').remove();
        })


    }
}

export const YouTubeEmbed = () => {
    document.addEventListener("DOMContentLoaded",

        function () {
            const youTubeContainers = document.querySelectorAll('.youtube-player');

            if (youTubeContainers.length > 0) {
                youTubeContainers.forEach(item => {
                    const div = document.createElement("div");
                    div.setAttribute("data-id", item.dataset.id);
                    div.innerHTML = thumb(item.dataset.id);
                    item.appendChild(div);
                    div.addEventListener('click', () => {
                        iframe(div);
                        item.classList.add('responsive-embed');
                    })
                });
            }

        });


    function thumb(id) {
        const thumb = '<img src="https://i.ytimg.com/vi/ID/maxresdefault.jpg" alt="">',
            play = '<div class="play"></div>';
        return thumb.replace("ID", id) + play;
    }

    function iframe(item) {
        const iframe = document.createElement("iframe");
        const embed = "https://www.youtube.com/embed/ID?autoplay=1";
        iframe.setAttribute("src", embed.replace("ID", item.dataset.id));
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allowfullscreen", "1");
        item.parentNode.replaceChild(iframe, item);
    }
};